export const aboutSections = [
  {
    img: "https://images.pexels.com/photos/5571713/pexels-photo-5571713.jpeg",
    type: "portrait",
    alt: "Student watching video homework on laptop",
    mission: "Video stands out as the most engaging content medium among Gen Z",
    read: "Whether your school still send homework in text only :(",
    heading: "h1",
    source: "Deloitte Insights",
    readMoreLink: "https://www.thecompanyfilms.com/insights/why-video-content-remains-the-most-engaging-media-format/",
  },
  {
    img: "https://images.pexels.com/photos/16094039/pexels-photo-16094039.jpeg",
    type: "portrait",
    alt: "Student doing homework with AI BOT (ChatGpt)",
    mission: "Use of AI for homework rose from 48% to 62%",
    read: "Are you still sending take-home writing assignments :(",
    source:"RAND's American Youth Panel",
    readMoreLink:"https://www.rand.org/news/press/2026/03/student-use-of-ai-for-homework-rises-as-concerns-grow.html",
    heading: "h2"
  },
  {
    img: "https://kryqqbxjefaszgjcxlxp.supabase.co/storage/v1/object/public/ocul_assets/Ocul_insta.png",
    type: "portrait",
    alt: "Interactive and engaging homework, attach youtube videos , images in homework.",
    mission: "Send Interactive and Exciting homework - Test Learning and Critical Thinking.",
    read: "Attach documentaries, self recorded explanation, videos and images from internet along with question -- Ask question from that , measure Real Learning not just Task completion.",
    heading: "h2",
    source:"OCUL AI"

  },
    {
    img: "https://kryqqbxjefaszgjcxlxp.supabase.co/storage/v1/object/public/ocul_assets/dual_coding.png",
    type: "portrait",
    alt: "Interactive and engaging homework, attach youtube videos , images in homework as combination of a visual and verbal code to learn something new is effective because it provides meaning in two complementary ways.",
    mission: "A picture is worth a thousand words.",
    read: "Dual Coding Theory proposes that information encoded through both verbal and visual representations can improve memory retention and understanding by creating multiple retrieval pathways.",
    heading: "h2",
    source:"Arthur Brisbane",
    readMoreLink:"https://sheilapontis.com/2019/01/31/implications-of-dual-coding-for-information-design/"

  },
   {
    img: "https://images.pexels.com/photos/8086357/pexels-photo-8086357.jpeg",
    type: "portrait",
    alt: "84% of teachers don't have enough time for their core duties like grading and lesson planning, so homework which will correct itself using AI.",
    mission: "84% of teachers don't have enough time for their core duties like grading and lesson planning.",
    read: "Our AI corrects every submission automatically. Teachers get a detailed dashboard showing exactly how each student is performing.No manual grading, no missed homework, no mistakes.",
    heading: "h2",
    source:"Pew Research Center",
    readMoreLink:"https://www.pewresearch.org/social-trends/2024/04/04/how-teachers-manage-their-workload/"

  },
  {
    img: "https://images.pexels.com/photos/18069083/pexels-photo-18069083.png",
    type: "portrait",
    alt: "Homework with audio video monitoring leading to lesser chances of cheating using ai tools and decreased learning.",
    mission: "Prepare for a AI future.",
    read: "With AI making cheating easier than ever, we've built real safeguards — live video and audio monitoring.Also watch and answer style assignments requires genuine engagement.",
    heading: "h2",
    source:"OCUL AI",
  },
  {
    img: "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800",
    type: "portrait",
    alt: "Homework correction using artifical intelligence which leads to regular feedback and increased performance.",
    mission: "Every student deserves feedback that actually helps them grow",
    read: "Research shows that homework with regular feedback and correction improves student achievement significantly more than homework alone.",
    heading: "h2",
    readMoreLink:"https://www.researchgate.net/publication/383972909_THE_IMPACT_OF_REGULARLY_CHECKING_HOMEWORK_ON_STUDENTS'_SUCCESS_IN_PRIMARY_SCHOOL"
  },
  {
    img: "https://images.pexels.com/photos/30945514/pexels-photo-30945514.jpeg",
    type: "portrait",
    alt: "Take a sample Test!",
    mission: "👉Try a sample Test!",
    read: "Link in read the study -- You can enter any name, class and roll number -- just explore freely, but do drop a feedback.",
    heading: "h2",
    source:"OCUL AI",
    readMoreLink:"https://useocul.com/test/cad30663-0bc0-462b-8428-53b7d1527ab1"
  },
    {
    img: "https://images.pexels.com/photos/4144772/pexels-photo-4144772.jpeg",
    type: "portrait",
    alt: "Feel free to contact us for query, complaint, feedback!",
    mission: "Feel free to contact us for query, complaint, feedback!",
    read: "Email: useocul@gmail.com",
    heading: "h2",
  }
];
